export interface EnvConfig {
  API_URL: string;
  SPLIT_CLIENT_API_KEY: string;
  RAYGUN_API_KEY: string;
  INTERCOM_APP: string;
  APP_VERSION: string;
  GOOGLE_API_KEY: string;
  LIVE_DATA_URL: string;
  ADMIN_URL: string;
  DEVEXTREME_DEVELOPER_LICENCE_KEY: string;
}

const liveDataUrlFallback =
  getEnvironment() === 'production'
    ? 'https://live.mooven.com'
    : 'https://live.dev.mooven.com';
const devExtremeLicenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImEzN2YyYWIyLTNlMWItNGM4OC05NTZhLTdkNjNkNDgxOThlMCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.ORbVfBEfiehk4xOEKYEgrhgDg4wRkelv+hCidxxXQXxt5dT+v2CQoMP9B4tzNt4KtbladXlFKkguyO2XghvYrAnAvUNuhcUEPwjGcOmNopkh3argIFD8oax2cBaQMx33S3iXkw==';

export const envConfig: EnvConfig = {
  ADMIN_URL: getAdminURL(),
  API_URL: getApiURL(),
  DEVEXTREME_DEVELOPER_LICENCE_KEY: devExtremeLicenseKey,
  RAYGUN_API_KEY: getRaygunApiKey(),
  INTERCOM_APP: getEnvironment() === 'production' ? 'rkrctuz0' : 'vucj8rl7',
  LIVE_DATA_URL: liveDataUrlFallback,
  SPLIT_CLIENT_API_KEY: process.env.SPLIT_CLIENT_API_KEY || '',
  APP_VERSION: process.env.APP_VERSION || 'local',
  GOOGLE_API_KEY: process.env.GOOGLE_API_KEY || '',
};

function isLocalEnv(location: Location): boolean {
  const { hostname } = location;
  return Boolean(
    hostname.includes('localhost') ||
      hostname.includes('ngrok-free.app') ||
      hostname.match(/\d+\.\d+\.\d+\.\d/)
  );
}

function getAdminURL(): string {
  const { hostname } = window.location;
  if (isLocalEnv(window.location) || hostname.includes('app.dev.')) {
    return 'https://admin.dev.mooven.com';
  }
  return 'https://admin.prod.mooven.com';
}

function getApiURL(): string {
  const { hostname } = window.location;
  if (isLocalEnv(window.location)) {
    return '';
  }
  const apiPrefix = 'https://api';
  return apiPrefix.concat('.', hostname);
}

export function getEnvironment(): 'local' | 'test' | 'production' {
  const { hostname } = window.location;
  if (isLocalEnv(window.location)) {
    return 'local';
  }
  if (hostname.includes('dev')) {
    return 'test';
  }
  return 'production';
}

export function getPublicViewURL(): string {
  switch (getEnvironment()) {
    case 'test':
      return 'https://live.dev.mooven.com';
    case 'production':
      return 'https://live.mooven.com';
    default:
      return 'https://live.dev.mooven.com';
  }
}

function getRaygunApiKey(): string {
  switch (getEnvironment()) {
    case 'test':
      return '1FVlJ8Kv0m6KZOyM54iiNg';
    case 'production':
      return 'gh9fXlZpBjVwxvTgb95emg';
    default:
      return '';
  }
}
